"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravellingEffluentSpreader = void 0;
const EffluentTracker_1 = require("./EffluentTracker");
const index_1 = require("../../DefinitionAndHelpers/index");
const typeName = 'TravellingEffluentSpreader';
const dev = process.env.REACT_APP_DEBUG;
const debug = dev && false;
class TravellingEffluentSpreader extends EffluentTracker_1.EffluentTracker {
    // DeviceEnabledType<SupportedDevices> {
    constructor(ob) {
        super(ob);
        this.type = typeName;
    }
    /**
     * Updated relevant runs. Allows runs of type TravellingEffluentSpreader
     * @param runList
     * @returns runs of correct run type
     */
    getRelevantRuns(runList) {
        debug && console.log('Using travelling specific - getRelevantRuns');
        return []; // stopping travelling paths
        // let filteredRuns = runList; // runList.filter((run) => run.pathType === EFFLUENT_PATH_TYPE.TravellingEffluentSpreader);
        // return filteredRuns;
    }
    getSpreadOfRawRun(relevantRun, path = this.path) {
        debug && console.log('Using TES - getSpreadOfRawRun');
        if (path && path.length > 1) {
            // linearlize the path
            // const x = path.map((p) => p.lat);
            // const y = path.map((p) => p.lng);
            // let mappedfindLineByLeastSquares(x, y) || path;
            let mapped = this.getPathOnRun(path); //relevantRun should always be undefined
            let turfBoundary = index_1.EffluentSpreaderHelper.getLineBoundaries(mapped, this.throwDistance || index_1.EFFLUENT_PATH_DEFAULT_RANGE);
            if (turfBoundary) {
                let positions = index_1.EffluentSpreaderHelper.convertTurfToPosition(turfBoundary.geometry.coordinates[0]);
                let area = index_1.EffluentSpreaderHelper.getAreaMeter(turfBoundary);
                return { positions, area };
            }
        }
        return undefined;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.TravellingEffluentSpreader = TravellingEffluentSpreader;
